<template>
  <a-modal
    :mask="false"
    width="720px"
    title="切换企业"
    :footer-hide="true"
    :maskClosable="false"
    :visible="$attrs.value"
    class="switchCompanies"
    @cancel="handleCancel">
    <ul class="companies">
      <li
        v-for="user in users"
        :key="user.id"
        :class="{ current: user.current }"
        @click="handleSelect(user.tenantId, user.current)"
      >
        <div class="ico-wrap">
          <span class="ico-company"></span>
          <span class="label">{{ user.tenantShortName }}</span>
          <span v-show="user.current" class="cur ml10">当前企业</span>
        </div>
        <sass-icon v-show="user.current" type="hi-gongneng-gouxuan" style="font-size: 24px;" />
      </li>
    </ul>
    <!-- 判断是否有人登录 -->
    <tip :isVisible="isTip" @close="doTip"/>
    <div slot="footer" class="modal-footer">
      <template>
        <!-- 此场景，不需要确定按钮 -->
        <!-- <a-button type="primary" class="btn" @click="handleSure">确认</a-button> -->
        <a-button @click="handleCancel">取消</a-button>
      </template>
    </div>
  </a-modal>
</template>
<script>
import CommonIcon from '@/components/common-icon'
import { mapGetters, mapActions } from 'vuex'
import { switchTenant, queryStatus, init, singOut } from '@/api/login'
import { getNumber } from '@/api/popup.js'
import tip from './tip.vue'
export default {
  name: 'SwitchCompanies',
  components: {
    CommonIcon,
    tip
  },
  computed: {
    ...mapGetters(['userList', 'userInfo']),
    users() {
      const userList = this.userList.length ? this.userList : this.$ls.get('userList')
      const tenantId = this.userInfo?.currentUser?.tenantId
      if (!userList) {
        return
      }
      return userList.map(item => {
        if (item.tenantId === tenantId) {
          item.current = true
        }
        return item
      })
    }
  },
  data() {
    return {
      isTip: false, // 是否显示提示
      changeId: null,
      confirmLoading: false
    }
  },
  methods: {
    ...mapActions(['GetInfo', 'GetSystemList', 'Logout', 'SetToken']),
    judgeStatus() {
      return queryStatus().then(res => {
        const data = res.data
        return Boolean(data && data.success)
      }).catch(() => {
        this.Logout()
      })
    },
    handleCancel() {
      this.$emit('input', false)
    },
    handleSelect(tenantId, current) {
      const {
        // $message,
        // GetInfo,
        // GetSystemList,
        $notification
        // GenerateRoutes
        // $route: { name: routeName }
      } = this
      const that = this
      if (current) return
      this.$confirm({
        title: '提示',
        content: '切换企业前请先保存数据，避免数据丢失。确认要切换企业吗？',
        // icon: 'close-circle',
        icon: () => <sass-icon type="hi-yiwen" style={{ fontSize: '20px' }} class="title-icon"/>,
        mask: false,
        closable: true,
        okText: '确认',
        cancelText: '取消',
        // class: 'wh-confirm',
        onOk() {
          switchTenant({ tenantId })
            .then(res => {
              // hasLoginedUsers
              if (res.data && res.data?.currentUser?.hasLoginedUsers === 1) {
                that.isTip = true
                // this.res = res
              } else {
                const token = res.data?.ucsAuthenToken
                sessionStorage.removeItem('ucs_system_list') // 切换用户清空system_list
                that.SetToken(token)
                that.$loading.show()
                // that.doNext()
                // location.reload()
                let url = document.location.origin
                url += '/ucs'
                window.open(url, '_self')
              }
            })
            .catch(err => {
              console.log(err)
              $notification.error({
                message: '错误',
                description: ((err.response || {}).data || {}).message || err.msg || '请求出现错误，请稍后再试',
                duration: 4
              })
            })
        }
      })
    },
    // 点击确认
    doTip (msg) {
      this.isTip = false
      if (msg === -1) return false
      if (msg === 1) {
        singOut().then(res => {
          console.log(res)
        }).catch(err => {
          console.log(err)
        })
      }
      this.$loading.show()
      this.doNext()
    },
    doNext () {
      const {
        $message,
        GetInfo,
        GetSystemList,
        $notification,
        // GenerateRoutes,
        $route: { name: routeName }
      } = this
      const that = this
      GetInfo().then(() => {
        GetSystemList().then(() => {
          // const roles = res.roles
          // 切换企业变成新角色要重新添加不同权限的路由
          that.$router.addRoutes(that.$store.getters.addRouters)
          that.judgeStatus().then(status => {
            this.$loading.hide()
            if (!status) {
              return init().then(ress => {
                const { data } = ress
                if (data && data.success) {
                  return true
                } else {
                  const msg = data.msg || '初始化租户信息失败'
                  $message.error(msg)
                  throw (new Error(msg))
                }
              })
            }
            return true
          }).catch(() => {
            this.$loading.hide()
            this.Logout()
          })
          const req = {}
          getNumber(req).then(res => {
            if (res.code === '0') {
              this.$store.commit('SET_NUMBER', res.data)
            }
          }).catch(err => {
            this.$notification.error({
              message: '错误',
              description: err.msg || '请求失败，请重试',
              duration: 3
            })
          })
          $message.success('企业切换成功！')
          that.$emit('input', false)
          if (routeName !== 'Home') {
            // 没有管理员权限也不在首页就跳转到首页
            // that.$router.replace({ name: 'Home' })
            that.$router.push({ path: '/home' })
          }
        })
      }).catch(err => {
        $notification.error({
          message: '错误',
          description: ((err.response || {}).data || {}).message || err.msg || '请求出现错误，请稍后再试',
          duration: 4
        })
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import '~ant-design-vue/lib/style/index';
.switchCompanies {
  .ant-modal-title {
    color: rgba(51,51,51,0.85);
    font-family: PingFangSC-Medium;
  }
  .ant-modal-header {
    padding: 14px 24px;
  }
}
.companies {
  font-size: 16px;
  height: 337px;
  max-height: 337px;
  overflow-y: auto;
  .btn {
    color: white;
  }
  & > li {
    display: flex;
    padding: 0 20px;
    height: 64px;
    cursor: pointer;
    justify-content: space-between;
    align-items: center;
  }
  .current {
    color: @primary-color;
    background: #f3f5f7;
    cursor: not-allowed;
  }
  .ico-wrap {
    display: flex;
    align-items: center;
    .cur {
      border-top-right-radius: 7px;
      border-bottom-left-radius: 7px;
      padding: 0 2px;
      width: 54px;
      height: 20px;
      font-size: 9px;
      line-height: 20px;
      color: #fff;
      background: #00a497;
      background-image: linear-gradient(220deg, #11877e 0%, #00a497 30%, #94d3ac 100%);
    }
    .label {
      margin-left: 16px;
      font-family: PingFangSC-Regular;
      font-size: 18px;
      line-height: 26px;
      color: #000;
    }
    .ico-company {
      display: inline-block;
      width: 32px;
      height: 32px;
      background: url('../images/company.svg');
    }
  }
}
.title-icon {
  float: left;
  margin-right: 16px;
  color: #faad14;
}
</style>
<style lang="less">
.ant-modal-body {
  padding: 24px 24px 0 24px;
}
.ant-modal-footer{
  height: 56px;
}
.ant-modal {
  .ant-modal-close {
    .ant-modal-close-x {
      background-repeat: no-repeat;
      background-size: 16px 16px;
      background-image: url(../images/close.png);
      background-position-x: center;
      background-position-y: center;
      svg {
        display: none;
      }
    }
  }
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
  ::-webkit-scrollbar{
    width: 6px;
    height: 6px;
    background-color: #F5F5F5;
  }

  /*定义滚动条轨道 内阴影+圆角*/
  ::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #ffffff;
  }

  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb{
    border-radius: 6px;
    background-color: #c8c8c8;
  }
</style>
